import { PromotionModel } from "@insite/client-framework/Types/ApiModels";

const SHIPPING_PROMOTION_TYPES = new Set(["AmountOffShipping", "PercentOffShipping"]);

export interface PromotionDisplayGroup {
    key: string;
    label: string;
    amount: number;
    promotion: PromotionModel;
}

export const getPromotionLabel = (promotion: PromotionModel) =>
    promotion.promotionCode?.trim() || promotion.name || promotion.id.split(":")[0];

export const getPromotionIdentity = (promotion: PromotionModel) =>
    getPromotionLabel(promotion).trim().toLowerCase();

export const isShippingPromotion = (promotion: PromotionModel) =>
    SHIPPING_PROMOTION_TYPES.has(promotion.promotionResultType);

export const isItemDiscountPromotion = (promotion: PromotionModel) =>
    !isShippingPromotion(promotion) && promotion.amount > 0;

export const groupPromotionResults = (
    promotions: PromotionModel[] | undefined,
    predicate: (promotion: PromotionModel) => boolean,
): PromotionDisplayGroup[] => {
    const groups = new Map<string, PromotionDisplayGroup>();

    (promotions ?? []).filter(predicate).forEach(promotion => {
        const identity = getPromotionIdentity(promotion);
        const current = groups.get(identity);
        if (current) {
            current.amount += promotion.amount;
            return;
        }

        groups.set(identity, {
            key: `${identity}-${promotion.promotionResultType}`,
            label: getPromotionLabel(promotion),
            amount: promotion.amount,
            promotion,
        });
    });

    return Array.from(groups.values());
};
